import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useState } from 'react';
import Action from '../action';
import { messages } from '../../../../../messages';
import { FormattedMessage } from 'react-intl-next';
import LinkIcon from '@atlaskit/icon/glyph/link';
import { useFlexibleUiAnalyticsContext, useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { ActionName } from '../../../../../constants';
import useInvokeClientAction from '../../../../../state/hooks/use-invoke-client-action';
var CopyLinkAction = function CopyLinkAction(_ref) {
  var _context$actions;
  var onClickCallback = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var context = useFlexibleUiContext();
  var analytics = useFlexibleUiAnalyticsContext();
  var invoke = useInvokeClientAction({
    analytics: analytics
  });
  var data = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[ActionName.CopyLinkAction];
  var _useState = useState(messages.copy_url_to_clipboard),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipMessage = _useState2[0],
    setTooltipMessage = _useState2[1];
  var onClick = useCallback(function () {
    if (data && data.url) {
      invoke({
        actionType: ActionName.CopyLinkAction,
        actionFn: function () {
          var _actionFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var _data$url;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return navigator.clipboard.writeText((_data$url = data.url) !== null && _data$url !== void 0 ? _data$url : '');
                case 2:
                  setTooltipMessage(messages.copied_url_to_clipboard);
                case 3:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function actionFn() {
            return _actionFn.apply(this, arguments);
          }
          return actionFn;
        }(),
        // These values have already been set in analytics context.
        // We only pass these here for ufo experience.
        display: analytics === null || analytics === void 0 ? void 0 : analytics.display,
        extensionKey: analytics === null || analytics === void 0 ? void 0 : analytics.extensionKey
      });
    }
    if (onClickCallback) {
      onClickCallback();
    }
  }, [analytics, data, invoke, onClickCallback]);
  return data ? /*#__PURE__*/React.createElement(Action, _extends({
    content: /*#__PURE__*/React.createElement(FormattedMessage, messages.copy_url_to_clipboard)
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
    ,
    icon: /*#__PURE__*/React.createElement(LinkIcon, {
      label: "copy url",
      size: "medium"
    }),
    onClick: onClick,
    testId: "smart-action-copy-link-action",
    tooltipMessage: /*#__PURE__*/React.createElement(FormattedMessage, tooltipMessage),
    tooltipOnHide: function tooltipOnHide() {
      return setTooltipMessage(messages.copy_url_to_clipboard);
    }
  }, data, props)) : null;
};
export default CopyLinkAction;